<app-global-user-settings
  [(isVisibleEteModal)]="isVisibleEteModal"
  [showExcelAdvanceOptions]="true"
  [showClose]="false"
  [(excelAdvancedDefault)]="excelAdvancedDefault"
  (close)="onCloseEteModal()"
></app-global-user-settings>
